<template>
  <div class="confirmation-container">
    <div class="grid-x grid-padding-y grid-padding-x">
      <div class="cell small-12 medium-7 margin-right-xxs margin-top-xs">
        <Skeleton height="80px" />
      </div>
    </div>
    <div class="grid-x grid-padding-y grid-padding-x">
      <div v-for="index in 2" :key="index" class="cell medium-6 margin-right-xxs">
        <Skeleton height="200px" />
      </div>
    </div>
    <div v-if="!returnLess" class="grid-x grid-padding-y grid-padding-x">
      <div v-for="index in 3" :key="index" class="cell medium-8 margin-right-xxs">
        <Skeleton height="80px" />
      </div>

      <div v-for="index in 2" :key="index" class="cell medium-9 margin-right-xxs">
        <Skeleton height="40px" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    returnLess: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
